export default "__VITE_ASSET__PTtCTZrT__"